<nav aria-label="pagination">
  <ul class="pagination d-flex flex-wrap justify-content-center mb-16">
    <li class="page-item pointer">
      <a class="page-link" aria-label="Previous" (click)="setFirst()">
        <fa-icon [icon]="faChevronCircleLeft" class="fal fa-chevron-double-left textColor harvest-gold base"></fa-icon>
        <span class="ml-3 pag-text">Primeiro</span>
      </a>
    </li>
    <li class="page-item pointer">
      <a class="page-link" aria-label="Previous" (click)="setMinus()">
        <fa-icon [icon]="faChevronLeft" class="fal fa-chevron-left textColor harvest-gold base"></fa-icon>
      </a>
    </li>
    <ng-container *ngFor="let it of arr">
      <li class="page-item" [class.pointer]="it != current" [class.active]="it == current"><a class="page-link" (click)="setP(it)">{{it}}</a></li>
    </ng-container>
    <li class="page-item pointer">
      <a class="page-link" aria-label="Next" (click)="setPlus()">
        <fa-icon [icon]="faChevronRight" class="fal fa-chevron-right textColor harvest-gold base"></fa-icon>
      </a>
    </li>
    <li class="page-item pointer">
      <a class="page-link" aria-label="Next" (click)="setLast()">
        <span class="mr-3 pag-text">Último</span>
        <fa-icon [icon]="faChevronCircleRight" class="fal fa-chevron-double-right textColor harvest-gold base"></fa-icon>
      </a>
    </li>
  </ul>
</nav>